export const environment = {
  production: true,
  buildId: '3684050563023151',
  configFile: 'config.json',
};
